import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import CommercialHeader from "@/components/commercial/CommercialHeader";
import { api, fmtEur, fmtDate } from "@/lib/commercialApi";
import { Loader2 } from "lucide-react";

export default function ComContracts() {
  const [rows, setRows] = useState(null);
  useEffect(() => { api.get("/contracts").then((r) => setRows(r.data.contracts)); }, []);
  return (
    <div className="min-h-screen bg-brand-paper">
      <CommercialHeader />
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10 py-8">
        <div className="eyebrow mb-1">Contrats signés</div>
        <h1 className="font-display text-3xl text-brand-ink mb-6">Contrats</h1>
        {rows === null ? <Loader2 className="h-4 w-4 animate-spin text-brand-subtle" />
          : rows.length === 0 ? (
          <div className="rounded-lg border border-brand-line bg-white p-10 text-center max-w-xl mx-auto">
            <div className="font-display text-xl text-brand-ink">Aucun contrat</div>
            <p className="mt-2 text-sm text-brand-subtle">
              Les contrats signés apparaissent ici automatiquement. Pour en créer un, va dans une opportunité en négociation et enregistre le contrat signé.
            </p>
            <Link to="/commercial/opportunites" className="mt-5 inline-flex items-center h-9 px-4 rounded-md bg-brand-ink text-white text-xs hover:bg-brand-moss">
              Voir les opportunités en négociation
            </Link>
          </div>
        ) : (
          <div className="rounded-lg border border-brand-line bg-white divide-y divide-brand-line">
            {rows.map((c) => (
              <Link key={c.id} to={`/commercial/opportunites/${c.opportunity_id}`} className="p-4 flex items-center justify-between gap-3 hover:bg-brand-paper">
                <div>
                  <div className="text-sm font-medium">{c.numero}</div>
                  <div className="text-xs text-brand-subtle mt-0.5">Signé le {fmtDate(c.signed_at)} · {c.duree_mois || "—"} mois · {c.commercial || "—"}</div>
                </div>
                <div className="text-sm font-mono">{fmtEur(c.montant_ht)}</div>
              </Link>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
